import React, { Component } from 'react'
import { Menu, Input, Icon, DatePicker, Pagination, Affix, Row } from "antd"
import RecycleCard from "app/components/normal/pgd/RecycleCard"
import recycleIcon from "app/styles/images/sp/recycle-bin-selected.svg"
import "./Index.scss"
import moment from "moment"
import { observer } from "mobx-react"
import cx from "classnames"
import dataRecycleSelectedIcon from "app/styles/images/sp/data-recycle-selected.svg"
import dataRecycleIcon from "app/styles/images/sp/data-recycle.svg"
import reportRecycleSelectedIcon from "app/styles/images/sp/report-recycle-selected.svg"
import reportRecycleIcon from "app/styles/images/sp/report-recycle.svg"
import Store from "app/stores/pgd/recycle"
import DataList from "./containers/DataList"

const RangePicker = DatePicker.RangePicker
const { Search } = Input

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.state = {
      currentPageIndex: 1,
      isHistory: "查看历史数据",
      dateValue: null,
      tableData: [],
      totalCount: 0,
      showCreateNewGroup: false,
      app: "0",              //头部筛选选中的状态 计算
      belong: "all",         //头部筛选选中的状态 自己 分享
      dayKey: "-1",          //头部筛选选中的状态 日期
      inputSearch: ""
    }
  }

  onDataChange = (e, type) => {
    this.store.tableData = []

    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  onBelongChange = (e) => {
    this.setState({
      belong: e.key,
    })
    let { getTableData, updateTableData, initOffset, initPageIndex, updateQueryMap } = this.store

    updateQueryMap({ belong: e.key })
    initOffset()
    getTableData()
      .then(
        res => {
          updateTableData(res)
          initPageIndex()
        }
      )
  }

  onAppChange = (e) => {
    this.setState({
      app: e.key,
    })
    let { getTableData, updateTableData, initPageIndex, initOffset, updateQueryMap, queryMap } = this.store
    let appQueryValue = null
    let isHistory = ""
    if (e.key === 0 || e.key === "0") {
      appQueryValue = null
      isHistory = "查看历史数据"
    } else if (e.key === "app_id_999" && queryMap.app === "999") {
      isHistory = "查看历史数据"
      appQueryValue = null
    } else if (e.key === "app_id_999" && (queryMap.app !== "999" || queryMap.app === null)) {
      isHistory = "关闭历史数据"
      appQueryValue = "999"
    } else {
      let appIdString = (e.key).replace("app_id_", "")
      appQueryValue = appIdString
      isHistory = "查看历史数据"
    }
    updateQueryMap({ app: appQueryValue })
    initOffset()
    this.setState({
      isHistory
    })
    getTableData(queryMap)
      .then(
        res => {
          updateTableData(res)
          initPageIndex()
        }
      )
  }

  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords
    })
  }
  searchData = () => {
    const { getTableData, initPageIndex, updateTableData, initOffset, updateQueryMap } = this.store
    updateQueryMap({ keywords: this.state.inputSearch })
    initOffset()
    getTableData()
      .then(
        res => {
          updateTableData(res)
          initPageIndex()
        }
      )
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let { getTableData, initPageIndex, updateTableData, initOffset, updateQueryMap, queryMap } = this.store
    updateQueryMap({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
    initOffset()
    getTableData(queryMap)
      .then(
        res => {
          updateTableData(res)
          initPageIndex()
        }
      )
  }

  dateChange = (dateValue, dateString) => {
    const { updateQueryMap } = this.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({     //日期回显
      dateValue: dateValue
    })
  }

  onDayChange = (e) => {
    let startDay = null
    let { getTableData, initPageIndex, updateTableData, initOffset, updateQueryMap, queryMap } = this.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }
    updateQueryMap({ start: startDay, end: null })
    initOffset()
    getTableData(queryMap)
      .then(
        res => {
          updateTableData(res)
          initPageIndex()
        }
      )
  }

  componentDidMount() {
    let { getTableData, initPageIndex, getApps, updateDataListData, queryMap } = this.store
    getApps('common', { filter: 'used' })
    getTableData(queryMap)
      .then(
        res => {
          updateDataListData(res)
          initPageIndex()
        }
      )
  }

  componentWillUnmount() {
    let { clearState } = this.store
    clearState()
  }

  onShowSizeChange = (current, pageSize) => {
    let { getTableData, initPageIndex, updateTableData, initOffset, updateQueryMap, queryMap } = this.store
    updateQueryMap({ limit: pageSize })
    initOffset()
    getTableData(queryMap)
      .then(
        res => {
          updateTableData(res)
          initPageIndex()
        }
      )
  }

  onPaginChange = selectedcurrentPageIndex => {
    const {
      getTableData,
      queryMap,
      updateQueryMap,
      updateTableData
    } = this.store

    this.store.currentPageIndex = selectedcurrentPageIndex
    document.getElementById("contentTop").scrollIntoView(true)
    updateQueryMap({ offset: (selectedcurrentPageIndex - 1) * queryMap.limit })
    getTableData(queryMap)
      .then(
        res => {
          updateTableData(res)
        }
      )
  }

  disabledDate = (current) => {
    return current && current.valueOf() > Date.now()
  }

  closeModal = (modal, cb) => {
    this.setState({
      [modal]: false
    })
    if (typeof cb === "function") {
      cb()
    }
  }

  render() {
    const { tableData, totalCount, currentPageIndex, queryMap, selectedRecycle } = this.store
    const { match, history } = this.props
    return (
      <div className="pgs recycle-bin-page">
        <h2 className="page-title"><img alt="" src={recycleIcon} />回收站</h2>
        {this.renderHeader()}
        {
          selectedRecycle === "data"
            ? <DataList store={this.store} match={match} history={history} />
            : (
              <div className="recycle-bin-card-wrap">
                {tableData.map((data, index) =>
                  <RecycleCard
                    key={data.groupId + "_groupId"}
                    data={data}
                    index={index}
                    store={this.store}
                  />
                )}
              </div>
            )
        }
        {
          selectedRecycle === "report" && (
            <div className="pagin-bottom">
              <Pagination
                showSizeChanger
                pageSize={queryMap.limit}
                onShowSizeChange={this.onShowSizeChange}
                onChange={this.onPaginChange}
                defaultCurrent={1}
                current={currentPageIndex}
                total={totalCount} />
            </div>
          )
        }
      </div>
    )
  }

  showCreateNewGroup = () => {
    // 拉数据
    this.setState({
      showCreateNewGroup: true
    })
  }

  renderHeader = () => {
    const { selectedRecycle } = this.store
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}>
        <div className="affix-back">
          {this.renderSearchMenu()}
          {this.renderDayMenu()}
          {
            selectedRecycle === "report"
              ? this.renderAppMenu()
              : null
          }
        </div>
      </Affix>
    )
  }

  switchRecycle = (type) => {
    let { getTableData, initPageIndex, clearState, getApps, updateDataListData, queryMap } = this.store

    this.store.setSelectedRecycle(type)
    this.setState({
      inputSearch: ""
    })
    if (type === "report") {
      getApps('common', { filter: 'used' })
      clearState()
      getTableData(queryMap)
        .then(
          res => {
            updateDataListData(res)
            initPageIndex()
          }
        )
    } else {
      clearState()
      getTableData(queryMap)
        .then(
          res => {
            updateDataListData(res)
            initPageIndex()
          }
        )
    }
  }

  renderSearchMenu = () => {
    const { selectedRecycle } = this.store
    const { inputSearch } = this.state
    const dataClass = cx({
      "data-recycle-bin-btn cursor-p": true,
      "selected": selectedRecycle === "data"
    })
    const reportClass = cx({
      "report-recycle-bin-btn cursor-p": true,
      "selected": selectedRecycle === "report"
    })
    const dataIcon = selectedRecycle === "data"
      ? dataRecycleSelectedIcon
      : dataRecycleIcon

    const reportIcon = selectedRecycle === "report"
      ? reportRecycleSelectedIcon
      : reportRecycleIcon

    return (
      <div className="recycle-bin-search-bar">
        <Row type="flex" justify="space-between" align="middle" className="content">
          <Row type="flex" align="middle">
            <div className="search-input">
              <Search
                value={inputSearch}
                placeholder="输入文件名/样本名/所在家系搜索"
                size="default"
                onChange={this.changeSearch}
                onSearch={this.searchData}
              />
            </div>
          </Row>
          <Row type="flex" align="middle">
            <Row
              type="flex"
              gutter={6}
              align="middle"
              onClick={() => this.switchRecycle("data")}
              className={dataClass}
            >
              <img src={dataIcon} alt="" />数据回收站
            </Row>
            <Row
              type="flex"
              gutter={6}
              align="middle"
              onClick={() => this.switchRecycle("report")}
              className={reportClass}
            >
              <img src={reportIcon} alt="" />报告回收站
            </Row>
          </Row>
        </Row>
      </div>
    )
  }

  renderAppMenu = () => {
    const { apps } = this.store

    return (
      <div className="menu-app-div">
        <Menu
          className="menu-app"
          onClick={e => this.onDataChange(e, "app")}
          selectedKeys={[this.state.app]}
          key="menu_app_0"
          mode="horizontal">
          <Menu.Item key="0">
            <Icon type="calculator" />全部计算
          </Menu.Item>
          {apps.map((item, index) =>
            <Menu.Item key={"app_id_" + item.id} title={item.name}>
              {item.name}
            </Menu.Item>
          )}
        </Menu>
      </div>
    )
  }

  renderDayMenu = () => {
    return (
      <div className="recycle-bin-search-time-bar">
        <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
          selectedKeys={[this.state.dayKey]}
          mode="horizontal"
          key="menu_date_0">
          <Menu.Item key="-1">
            <Icon type="calendar" />全部
          </Menu.Item>
          <Menu.Item key="0">今天</Menu.Item>
          <Menu.Item key="3">三天内</Menu.Item>
          <Menu.Item key="7">七天内</Menu.Item>
          <Menu.Item key="15">十五天内</Menu.Item>
          <Menu.Item key="30">三十天内</Menu.Item>
        </Menu>
        <RangePicker
          ranges={{
            "今天": [moment(), moment()],
            "本月": [moment().startOf("month"), moment()]
          }}
          showTime
          value={this.state.dateValue}
          onChange={this.dateChange}
          onOk={this.dateChangeOk}
          disabledDate={this.disabledDate}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/recycleBin/index.js